import {useContext} from 'react'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PURCHASER_REPORT_COLUMNS} from '../../utils'
import PurchaserReportTableRow from './PurchaserReportTableRow'
import {PurchaserReportContext} from '../../context'

const PurchaserReportTable = () => {
  const {purchaserData, isLoading, onSortingChange, filters} = useContext(PurchaserReportContext)

  return (
    <DynamicTable
      id='purchaser-report-table'
      data={purchaserData}
      sortableColumns={PURCHASER_REPORT_COLUMNS}
      TableRow={PurchaserReportTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
      noDataMessage='No purchaser inquiry data found'
      permissionPath='inquires'
    />
  )
}

export default PurchaserReportTable
